module.exports = __webpack_public_path__ + "img/Audit.06c5df5a.svg";